module.exports = __webpack_public_path__ + "img/curso.abc512bf.svg";